var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hackReset)?_c('div',{staticClass:"h-full"},[_c('div',{class:_vm.config.isDetailDisplay ? 'small-list' : 'scroll-auto'},[_c('Control',{ref:"control",attrs:{"config":_vm.config},on:{"onChangeEditDataSource":_vm.onChangeEditDataSource}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }